var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "properties-field", attrs: { id: _vm.id } }, [
    _c("div", { staticClass: "wrap-properties" }, [
      _c("div", { staticClass: "properties-field-title" }, [
        _c("h4", { staticClass: "title" }, [_vm._v("Properties")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "close-properties",
            on: {
              click: function($event) {
                _vm.submitForm(true)
              }
            }
          },
          [_vm._v("\n        ×\n      ")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "wrap-type" }, [
          _c("img", {
            attrs: {
              src: require("@/assets/new-form-ui/field-icon/" +
                (_vm.fieldDetail.type === "form_ui" ? "single" : "multiple") +
                "_experience_manager.svg")
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "text-type" }, [
            _vm._v(
              "\n          " +
                _vm._s(
                  _vm.fieldDetail.type === "form_ui" ? "Single" : "Multiple"
                ) +
                " Experience Manager\n        "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "properties-field-content" }, [
        _c(
          "div",
          { staticClass: "section-field input-field" },
          [
            _c(
              "b-form",
              { class: { "error-input": _vm.$v.dataSetup.title.$error } },
              [
                _c("label", [_vm._v("Title")]),
                _vm._v(" "),
                _c("j-input", {
                  attrs: { placeholder: "Ex: List Data..." },
                  model: {
                    value: _vm.dataSetup.title,
                    callback: function($$v) {
                      _vm.$set(_vm.dataSetup, "title", $$v)
                    },
                    expression: "dataSetup.title"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form",
              { class: { "error-input": _vm.$v.dataSetup.form_ui.$error } },
              [
                _c("label", [_vm._v(" Experience Manager")]),
                _vm._v(" "),
                _c("j-single-select", {
                  attrs: {
                    "load-options": _vm.loadOptionsFormUI,
                    "is-async": true,
                    "cache-option": false,
                    placeholder: "Experience Manager",
                    "value-format": "object",
                    label: "name"
                  },
                  model: {
                    value: _vm.dataSetup.form_ui,
                    callback: function($$v) {
                      _vm.$set(_vm.dataSetup, "form_ui", $$v)
                    },
                    expression: "dataSetup.form_ui"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "section-field input-field" }, [
          _c("h4", { staticClass: "title-section" }, [_vm._v("Primary View")]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "configuration-section",
              class: { "error-input": _vm.$v.dataSetup.selected_view.$error }
            },
            [
              _c("h4", { staticClass: "configuration-section-title mb-2" }, [
                _vm._v("Web")
              ]),
              _vm._v(" "),
              _vm.list_view.length > 0 || !_vm.isLoading
                ? _c(
                    "div",
                    { staticClass: "div-view" },
                    _vm._l(_vm.list_view, function(view) {
                      return _c(
                        "div",
                        {
                          key: view.id,
                          staticClass: "view",
                          class: {
                            active:
                              _vm.dataSetup.selected_view &&
                              _vm.dataSetup.selected_view.id === view.id,
                            disabled: !view.hasSetup
                          },
                          on: {
                            click: function($event) {
                              _vm.selectView(view, true)
                            }
                          }
                        },
                        [
                          _vm.dataSetup.selected_view &&
                          _vm.dataSetup.selected_view.id === view.id
                            ? _c("img", {
                                attrs: {
                                  src: require("@/assets/new-form-ui/icon-active/" +
                                    view.icon +
                                    ".svg")
                                }
                              })
                            : _c("img", {
                                attrs: {
                                  src: require("@/assets/new-form-ui/icon/" +
                                    view.icon +
                                    ".svg")
                                }
                              }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(view.name))])
                        ]
                      )
                    })
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.list_view.length === 0
                ? _c(
                    "div",
                    {
                      staticClass: "warning-function d-flex align-items-center"
                    },
                    [
                      _c("img", {
                        attrs: { src: require("@/assets/icon/warning.svg") }
                      }),
                      _vm._v(" "),
                      _vm._m(0)
                    ]
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "configuration-section",
              class: {
                "error-input": _vm.$v.dataSetup.selected_view_small.$error
              }
            },
            [
              _c("h4", { staticClass: "configuration-section-title mb-2" }, [
                _vm._v("Mobile")
              ]),
              _vm._v(" "),
              _vm.list_view_small.length > 0 || !_vm.isLoading
                ? _c(
                    "div",
                    { staticClass: "div-view" },
                    _vm._l(_vm.list_view_small, function(view) {
                      return _c(
                        "div",
                        {
                          key: view.id,
                          staticClass: "view",
                          class: {
                            active:
                              _vm.dataSetup.selected_view_small &&
                              _vm.dataSetup.selected_view_small.id === view.id,
                            disabled: !view.hasSetup
                          },
                          on: {
                            click: function($event) {
                              _vm.selectView(view, false)
                            }
                          }
                        },
                        [
                          _vm.dataSetup.selected_view_small &&
                          _vm.dataSetup.selected_view_small.id === view.id
                            ? _c("img", {
                                attrs: {
                                  src: require("@/assets/new-form-ui/icon-active/" +
                                    view.icon +
                                    ".svg")
                                }
                              })
                            : _c("img", {
                                attrs: {
                                  src: require("@/assets/new-form-ui/icon/" +
                                    view.icon +
                                    ".svg")
                                }
                              }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(view.name))])
                        ]
                      )
                    })
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.list_view_small.length === 0
                ? _c(
                    "div",
                    {
                      staticClass: "warning-function d-flex align-items-center"
                    },
                    [
                      _c("img", {
                        attrs: { src: require("@/assets/icon/warning.svg") }
                      }),
                      _vm._v(" "),
                      _vm._m(1)
                    ]
                  )
                : _vm._e()
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "section-field input-field" }, [
          _c("h4", { staticClass: "title-section" }, [
            _vm._v("Parse value to")
          ]),
          _vm._v(" "),
          !_vm.isLoading
            ? _c(
                "div",
                { staticClass: "d-flex" },
                [
                  _c(
                    "b-form-group",
                    {
                      class: {
                        "error-input": _vm.$v.dataSetup.filter_variable.$error
                      }
                    },
                    [
                      _c("label", [_vm._v(" Column (This Component) ")]),
                      _vm._v(" "),
                      _c("j-single-select", {
                        attrs: {
                          options: _vm.list_filter_column,
                          label: "label",
                          "value-format": "object",
                          placeholder: "Select Column"
                        },
                        model: {
                          value: _vm.dataSetup.filter_column,
                          callback: function($$v) {
                            _vm.$set(_vm.dataSetup, "filter_column", $$v)
                          },
                          expression: "dataSetup.filter_column"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "equal",
                    attrs: { src: require("@/assets/new-form-ui/equal.svg") }
                  }),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      class: {
                        "error-input": _vm.$v.dataSetup.filter_column.$error
                      }
                    },
                    [
                      _c("label", [_vm._v(" Column (Main UI) ")]),
                      _vm._v(" "),
                      _c("j-single-select", {
                        attrs: {
                          options: _vm.options,
                          label: "label",
                          "value-format": "object",
                          placeholder: "Select Column"
                        },
                        model: {
                          value: _vm.dataSetup.filter_variable,
                          callback: function($$v) {
                            _vm.$set(_vm.dataSetup, "filter_variable", $$v)
                          },
                          expression: "dataSetup.filter_variable"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "d-flex" },
                [
                  _c(
                    "b-form-group",
                    [
                      _c("label", [_vm._v(" Column (This Component) ")]),
                      _vm._v(" "),
                      _c("j-single-select", {
                        attrs: { disabled: true, placeholder: "Select Column" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "equal",
                    attrs: { src: require("@/assets/new-form-ui/equal.svg") }
                  }),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    [
                      _c("label", [_vm._v(" Column (Main UI) ")]),
                      _vm._v(" "),
                      _c("j-single-select", {
                        attrs: { disabled: true, placeholder: "Select Column" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "properties-field-button",
          class: { "justify-content-end": !_vm.fieldDetail }
        },
        [
          _vm.fieldDetail
            ? _c(
                "button",
                {
                  staticClass: "button-border",
                  on: { click: _vm.deleteConfiguration }
                },
                [
                  _c("i", { staticClass: "fa fa-trash" }),
                  _vm._v(" Delete\n      ")
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex align-items-center" }, [
            _c(
              "button",
              {
                staticClass: "button-border mr-2",
                on: {
                  click: function($event) {
                    _vm.submitForm(true)
                  }
                }
              },
              [_vm._v("\n          Close\n        ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "button-blue",
                on: {
                  click: function($event) {
                    _vm.submitForm(false)
                  }
                }
              },
              [_vm._v("\n          Apply\n        ")]
            )
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex flex-column" }, [
      _c("span", [
        _vm._v("Please select "),
        _c("b", [_vm._v("Experience Manager")]),
        _vm._v(" first!")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex flex-column" }, [
      _c("span", [
        _vm._v("Please select "),
        _c("b", [_vm._v("Experience Manager")]),
        _vm._v(" first!")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53fbe255", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53fbe255","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/partials/configuration/ComponentConfiguration.vue
// module id = null
// module chunks = 